const { default: axios } = require("axios");

//import './main.js';
(function() {
    "use strict";
    var swalTitle               = "Are you sure?";
    var swalConfirmDeleteMsg    = "You won't be able to revert this!";
    var swalConfirmBtn          = "Yes, delete";
    var swalCancelBtn           = "Cancel";
    var swalCancelBtnColor      = "#ff3547";
    var swalConfirmBtnColor     = "#00c851";
    var swalBtnBlue             = "#0d6efd";
    var swalBtnRed              = "#d33";
    var swalBtnGreen            = "#198754";

    var userDataTable;

    var handymanScript = {
        generalElements: function() {
            /**
             * Setup CSRF token in ajax request
             */
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            /**
             * This is for delete buttons that are loaded via AJAX in datatables, they will not work right
             * without this block of code
             */
            $(document).ajaxComplete(function(){
                handymanScript.addDeleteForms();
                $('.hmselect2').select2({});
            });


            /**
             * Generic confirm form delete using Sweet Alert
             */
            $('body').on('submit', 'form[name=delete_item]', function(e) {
                e.preventDefault();
                var form = this;
                var link = $('a[data-method="delete"]');
                var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                Swal.fire({
                    title: title,
                    text: text,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: cancel,
                    confirmButtonText: confirm,
                    reverseButtons: true,
                }).then((result) => {
                    if (result.isConfirmed) {
                        form.submit();
                    }
                })
            });

            // Initialize select2
            $('.hmselect2').select2({

            });

            // Set default config for jquery validate
            $.validator.setDefaults({
                debug: false,
                errorClass: 'is-invalid',
                validClass: 'is-valid',
                errorElement: 'div',
                errorPlacement: function(error, element) {
                    error.addClass('invalid-feedback');
                    if (element.prop( "type" ) === "checkbox" ) {
                        error.insertAfter( element.next("label" ) );
                    } else if(element.prop( "type" ) === "select-one") {
                        error.insertAfter( element.next('span') );
                    } else {
                        error.insertAfter( element );
                    }
                    //error.insertAfter( element );
                }
            });

            // Validate all the form which have .form-validate class
            $('.form-validate').each(function() {
                $(this).validate({
                    submitHandler: function(form) {
                        handymanScript.disableSubmitButton();
                        form.submit();
                    }
                });
            });

            // Display profile pic preview
            $('#profile_pic').change(function(event) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    $('.profile_pic_preview').attr('src', e.target.result).show();
                };
                reader.readAsDataURL(event.target.files[0]);
            });
        },
        /**
         * Allows you to add data-method="METHOD to links to automatically inject a form
         * with the method on click
         *
         * Example: <a href="{{route('customers.destroy', $customer->id)}}"
         * data-method="delete" name="delete_item">Delete</a>
         *
         * Injects a form with that's fired on click of the link with a DELETE request.
         * Good because you don't have to dirty your HTML with delete forms everywhere.
         */
        addDeleteForms: function() {
            $('[data-method]').append(function () {
                if (! $(this).find('form').length > 0)
                    return "\n" +
                        "<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                        "   <input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
                        "   <input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                        "</form>\n";
                else
                    return "";
            })
                .removeAttr('href')
                .attr('style', 'cursor:pointer;')
                .attr('onclick', '$(this).find("form").submit();');
        },
        // Bulk check / uncheck
        bulkCheckUncheck: function () {
            // Bulk delete
            // When check/uncheck the check all button
            $('#checked-all').on('change', function () {
                if($(this).is(':checked')) {
                    $('.single-check').prop('checked', true).trigger('change');
                }
                else {
                    $('.single-check').prop('checked', false).trigger('change');
                }
            });

            // when check / uncheck single checkbox
            $('body').on('change', '.single-check', function () {
                let totalItems = $('.single-check').length;
                let totalCheckedItems = $('.single-check:checked').length;
                if(totalCheckedItems === 0) {
                    $('#checked-all').prop('checked', false);
                    $('#checked-all').prop('indeterminate', false);
                }
                else if(totalCheckedItems < totalItems) {
                    $('#checked-all').prop('indeterminate', true);
                }
                else if(totalCheckedItems === totalItems) {
                    $('#checked-all').prop('checked', true);
                    $('#checked-all').prop('indeterminate', false);
                }

                // Show / hide bulk delete button
                if(totalCheckedItems > 0) {
                    $('#bulk-delete-row').removeClass('d-none');
                }
                else {
                    $('#bulk-delete-row').addClass('d-none');
                }
            });
        },
        displayToastNotification: function(type, heading, message) {
            $.toast({
                heading: heading,
                text: message,
                position: 'top-right',
                showHideTransition: 'slide',
                icon: type
            })
        },
        // Disabled the submit button
        disableSubmitButton: function () {
            $('button[type="submit"]').attr('disabled', true).addClass('disabled');
        },
        // Initialize users dataTable
        userDataTable: function () {
            if($('#users-table').length) {
                userDataTable = $('#users-table').DataTable({
                    pageLength: 10,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: user_list_route,
                        type: 'post',
                        data: function(d) {

                        }
                    },
                    columns: [
                        //{data: 'bulk_action', name: 'bulk_action', searchable: false, sortable: false},
                        {data: 'name', name: 'name'},
                        {data: 'email', name: 'email'},
                        {data: 'phone_number', name: 'phone_number'},
                        {data: 'role', name: 'role'},
                        {data: 'status', name: 'status', class: 'text-center'},
                        {data: 'created_at', name: 'created_at', class: 'text-center'},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center'}
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[5, "asc"]],
                    searchDelay: 500
                });

                // Bulk delete users
                $('#bulk-delete-btn').on('click', function () {
                    var ids = [];
                    $('input[type="checkbox"][name="ids[]"]:checked').each(function () {
                        ids.push($(this).val());
                    });
                    Swal.fire({
                        title: 'Are you sure?',
                        text: 'You won\'t be able to revert this!',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancel',
                        confirmButtonText: 'Yes, delete',
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            var buttonHtml = $(this).html();

                            // Enable loading on delete button
                            $(this).attr('disabled', true).html('<span class="spinner-border spinner-border-sm" role="status"></span> Deleting...');
                            axios.post(user_bulk_delete_route, {ids: ids})
                                .then(function (response) {
                                    $('#bulk-delete-btn').attr('disabled', false).html(buttonHtml);
                                    $('#bulk-delete-row').addClass('d-none');
                                    $('#checked-all').prop('checked', false);
                                    $('#checked-all').prop('indeterminate', false);
                                    userDataTable.ajax.reload();
                                    if (response.data.status == 'success') {
                                        handymanScript.displayToastNotification('success', 'Success', 'Selected users deleted.');
                                    }
                                    else {
                                        handymanScript.displayToastNotification('error', 'Error', 'Unable to delete, please try again.');
                                    }
                                })
                                .catch(function (error) {

                                })
                        }
                    })
                });

                // Delete user
                $('body').on('click', '.delete-user', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    userDataTable.ajax.reload();
                                })
                        }
                    })
                })

                // Filter data
                // $('#filter-result').on('click', function () {
                //     $('#filter-result').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Searching...').addClass('disabled');
                //     userDataTable.ajax.reload();
                // });

                // // Reset filter
                // $('#reset-filters').on('click', function () {
                //     $('select[name="referred_by"]').val('').trigger('change');
                //     $('select[name="game_played"]').val('').trigger('change');
                //     $('select[name="deposit"]').val('').trigger('change');
                //     $('select[name="withdraw"]').val('').trigger('change');
                //     $('select[name="balance"]').val('').trigger('change');
                //     $('select[name="bonus"]').val('').trigger('change');
                //     $('select[name="spend"]').val('').trigger('change');
                //     $('select[name="lose"]').val('').trigger('change');
                //     $('select[name="win"]').val('').trigger('change');

                //     userDataTable.ajax.reload();
                // })
            }
        },
        handleUserCreate() {
            // Validate and submit create user form
            if ($('#createUserForm').length > 0) {
                $('#createUserForm').validate({ // initialize the plugin
                    rules: {
                        password: {
                            minlength: 8
                        },
                        confirm_password: {
                            minlength: 8,
                            required: true,
                            equalTo: '#password'
                        }
                    },
                    messages: {
                        confirm_password: {
                            equalTo: 'Passwords do not match'
                        }
                    },
                    submitHandler: function(form) {
                        $(form)
                            .find('button[type="submit"]')
                            .attr('disabled', true)
                            .addClass('disabled')
                            .html('Processing...');
                        form.submit();
                    }
                });
            }
        },
        // Validate change password form
        validateChangePasswordForm: function () {
            $(".change-password-form").validate({
                rules: {
                    current_password: {
                        required: true
                    },
                    new_password: {
                        required: true
                    },
                    new_password_confirmation: {
                        required: true,
                        equalTo: "#new_password"
                    }
                },
                messages: {
                    current_password: {
                        required: "Please enter your current password."
                    },
                    new_password: {
                        required: "Please enter a new password."
                    },
                    new_password_confirmation: {
                        required: "Please confirm your new password.",
                        equalTo: "Passwords do not match with new password."
                    }
                },
                submitHandler: function(form) {
                    form.submit();
                }
            });
        },
        activityLogDataTable() {
            if ($('#activity-log-table').length > 0) {
                var activityLogDataTable = $('#activity-log-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: activity_list_route,
                        type: 'post',
                        data: function(d) {

                        }
                    },
                    columns: [
                        {data: 'user', name: 'user'},
                        {data: 'action', name: 'action'},
                        {data: 'description', name: 'description'},
                        {data: 'created_at', name: 'created_at', class: 'text-center'},
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[3, "desc"]],
                    searchDelay: 500
                });
            }
        },
        init: function () {
            handymanScript.generalElements();
            handymanScript.addDeleteForms();
            handymanScript.bulkCheckUncheck();
            handymanScript.userDataTable();
            handymanScript.validateChangePasswordForm();
            handymanScript.activityLogDataTable();
        },
    };
    // Initialize the script
    handymanScript.init();
})();
